import React from 'react';
import styled from 'styled-components/macro';
import { CheckOutlined, LinkOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import MenuItem from 'antd/lib/menu/MenuItem';
import { ANTD_GRAY } from '../../../entity/shared/constants';
import { useTranslation } from '../../../../i18n/useTranslation';
import { transformUrl } from '../../url_utils/urlTransformer';

interface CopyLinkMenuItemProps {
    key: string;
    isCopied: boolean;
    onCopy: (str) => void;
}

const StyledMenuItem = styled(MenuItem)`
    && {
        width: 100%;
        color: ${ANTD_GRAY[8]};
        background-color: ${ANTD_GRAY[1]};
    }
`;

const TextSpan = styled.span`
    padding-left: 12px;
`;

const StyledLinkOutlined = styled(LinkOutlined)`
    font-size: 14px;
`;

export default function CopyLinkMenuItem(props: CopyLinkMenuItemProps) {
    const { t } = useTranslation();
    const { isCopied, onCopy } = props;
    return (
        <StyledMenuItem
            {...props}
            onClick={() => {
                const transformedUrl = transformUrl(window.location.href);
                navigator.clipboard.writeText(transformedUrl);
                onCopy('LINK');
            }}
        >
            <Tooltip placement="right" title={t('Copy a shareable link to this entity.')}>
                {isCopied ? <CheckOutlined /> : <StyledLinkOutlined />}
                <TextSpan>
                    <b>{t('Copy Link')}</b>
                </TextSpan>
            </Tooltip>
        </StyledMenuItem>
    );
}
